export default {
  SHOW_HOLDINGS_HEADER: "Your Portfolio",
  SHOW_HOLDINGS_SUBHEADING: {
    label: "Total Value",
    value: 5232.24,
  },
  SHOWABLE_ITEMS: [
    [
      {
        label: "VTI",
        value: 238.21,
      },
      {
        label: "10% of portfolio",
      },
      {
        label: "Number of Shares",
        value: 42.53,
      },
      {
        label: "Value in Portfolio",
        value: 10131.07,
      },
      {
        label: "Vanguard Total Stock Market Index Fund ETF",
      },
    ],
    [
      {
        label: "VXUS",
        value: 62.73,
      },
      {
        label: "10% of portfolio",
      },
      {
        label: "Number of Shares",
        value: 42.53,
      },
      {
        label: "Value in Portfolio",
        value: 10131.07,
      },
      {
        label: "Vanguard Total International Stock ETF",
      },
    ],
    [
      {
        label: "BND",
        value: 85.26,
      },
      {
        label: "80% of portfolio",
      },
      {
        label: "Number of Shares",
        value: 42.53,
      },
      {
        label: "Value in Portfolio",
        value: 10131.07,
      },
      {
        label: "Vanguard Total Bond Market Index Fund ETF",
      },
    ],
  ],
  SHOW_HOLDINGS_HEADER_2: "Transaction History",
  SHOW_HOLDINGS_TRANSACTION_HISTORY: [
    {
      label: "$100.00 Withdrawal from Account",
      subheading: "September 15, 2021",
    },
    {
      label: "SELL 52 shares of VTI at $42.53",
      subheading: "September 14, 2021",
    },
    {
      label: "BUY 52 shares of VTI at $42.53",
      subheading: "September 13, 2021",
    },
    {
      label: "$100.00 Account Funding",
      subheading: "September 12, 2021",
    },
  ],
  SHOW_HOLDINGS_BUTTON_HEADING: "Check Status",
  SHOW_HOLDINGS_BUTTON_HEADING_2: "Sell and Withdraw Assets",
  Status :{
    Active: 'active asset',
    Sold: 'being sold'
  }
};
